<template>
    <Form
        :errors="errors"
        :product="product"
        :product-groups="productGroups"
        :dns-templates="dnsTemplates"
        :accounting-products="accountingProducts"
        :intercompany-accounting-products="intercompanyAccountingProducts"
        :fulfillment-strategies="fulfillmentStrategies"
        :preselected-downgrades="preselectedDowngrades"
        :preselected-upgrades="preselectedUpgrades"
        :is-short-termination-period-set="isShortTerminationPeriodSet"
        :invoice-behaviours="invoiceBehaviours"
        :sub-types="subTypes"
        :default-tenant-language="defaultTenantLanguage"
        :tenant-languages="tenantLanguages"
        :possible-addon-groups="possibleAddonGroups"
        :is-invoice-before-renewal-enabled="isInvoiceBeforeRenewalEnabled"
        :product-classes="productClasses"
        :termination-rules="terminationRules"
        :default-addons="defaultAddons"
        :terms-and-conditions-types="termsAndConditionsTypes"
        :requires-domain-options="requiresDomainOptions"
        :billing-types="billingTypes"
        :taxonomy-hierarchy="taxonomyHierarchy"
        @form-submitted="submitData"
    />
</template>

<script>
import Form from '~@/Components/Products/Products/Form'

export default {
    name: 'ProductUpdate',
    components: {
        Form
    },
    props: {
        errors: {
            type: Object,
            default () {
                return {}
            }
        },
        product: {
            type: Object,
            default () {
                return {}
            }
        },
        productGroups: {
            type: Array,
            default () {
                return []
            }
        },
        dnsTemplates: {
            type: Array,
            default () {
                return []
            }
        },
        accountingProducts: {
            type: Array,
            default () {
                return []
            }
        },
        intercompanyAccountingProducts: {
            type: Array,
            default () {
                return []
            }
        },
        fulfillmentStrategies: {
            type: Array,
            default () {
                return []
            }
        },
        preselectedDowngrades: {
            type: Array,
            default () {
                return []
            }
        },
        preselectedUpgrades: {
            type: Array,
            default () {
                return []
            }
        },
        invoiceBehaviours: {
            type: Array,
            default () {
                return []
            }
        },
        subTypes: {
            type: Array,
            default () {
                return []
            }
        },
        isShortTerminationPeriodSet: {
            type: Boolean,
            default: () => { return false }
        },
        defaultTenantLanguage: {
            type: String,
            default: ''
        },
        tenantLanguages: {
            type: Array,
            default: () => { return [] }
        },
        possibleAddonGroups: {
            type: Array,
            default: () => { return [] }
        },
        isInvoiceBeforeRenewalEnabled: {
            type: Boolean,
            default: false
        },
        productClasses: {
            type: Array,
            default: () => { return [] }
        },
        terminationRules: {
            type: Array,
            default: () => { return [] }
        },
        defaultAddons: {
            type: Array,
            default: () => { return [] }
        },
        termsAndConditionsTypes: {
            type: Array,
            default: () => { return [] }
        },
        requiresDomainOptions: {
            type: Array,
            default: () => { return [] }
        },
        billingTypes: {
            type: Array,
            default: () => { return [] }
        },
        taxonomyHierarchy: {
            type: Object,
            default: () => { return {} }
        },
    },
    methods: {
        submitData (form) {
            const newForm = { ...form }
            newForm.selectedDowngrades = newForm.selectedDowngrades.map((val) => val.value)
            newForm.selectedUpgrades = newForm.selectedUpgrades.map((val) => val.value)

            newForm.put(this.$route('products.products.update', this.product.id))
        }
    }
}
</script>
